import { api } from '../index';

const prefix = '/api/sc/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectStoreCreditList(param) {
	return api.post(prefix + 'selectStoreCreditList', param);
}

export function apiSelectStoreCredit(param) {
	return api.post(prefix + 'selectStoreCredit', param);
}

export function apiInsertStoreCredit(param) {
	param.mode = 'insert';
	return apiSubmitStoreCredit(param);
}

export function apiUpdateStoreCredit(param, status_changed) {
	param.mode = 'update';
	if (status_changed) param.status_changed = true;
	return apiSubmitStoreCredit(param);
}

export function apiDeleteStoreCredit(param) {
	param.mode = 'delete';
	return apiSubmitStoreCredit(param);
}

function apiSubmitStoreCredit(param) {
	return api.post(prefix + 'submitStoreCredit', param);
}

export function apiProcessPayment(param) {
	return api.post(prefix + 'processPayment', param);
}

export function apiSelectUsedARInvoice(param) {
	return api.post(prefix + 'selectUsedARInvoice', param);
}

// export function apiInsertPartnerDocInfo(param) {
// 	param.mode = 'insert';
// 	return apiSubmitPartnerDocInfo(param);
// }

// export function apiDeletePartnerDocInfo(param) {
// 	param.mode = 'delete';
// 	return apiSubmitPartnerDocInfo(param);
// }

// function apiSubmitPartnerDocInfo(param) {
// 	return api.post(prefix + 'submitPartnerDocInfo', param);
// }

// export function apiSelectMemoList(param) {
// 	return api.post(prefix + 'selectMemoList', param);
// }

// export function apiSubmitMemo(param) {
// 	return api.post(prefix + 'submitMemo', param);
// }
